export interface Chapter {
  id: string;
  number: number;
  title: string;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  description: string;
  coverImage: string;
  rating: number;
  views: number;
  status: string;
  updatedAt: string;
  chapters: Chapter[];
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事，感受心跳加速的每一刻' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '穿越异世界的奇幻冒险，展开想象力的翅膀' },
  { name: '动作', slug: 'action', icon: 'ri-flashlight-line', description: '热血沸腾的战斗场面，紧张刺激的动作漫画' },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', description: '扑朔迷离的悬疑剧情，一步步揭开真相' },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '令人捧腹的搞笑日常，治愈你的不开心' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', description: '深刻动人的剧情故事，感受人生百态' },
];

const chTitles = [
  '命运的相遇', '初次的对话', '心动的瞬间', '无法言说的秘密',
  '暴风雨来临', '意外的重逢', '新的开始', '靠近的心',
  '离别之路', '重逢之时', '甜蜜约会', '误会的开始',
  '真相大白', '最后的决战', '永恒之约',
];

function ch(m: number, d: number): string {
  return '2026-' + (m < 10 ? '0' + m : '' + m) + '-' + (d < 10 ? '0' + d : '' + d);
}

export const comics: Comic[] = [
  {
    id: '1', slug: 'starry-love', title: '星光下的约定', author: '金智恩',
    category: '恋爱', categorySlug: 'romance',
    description: '在首尔的星空下，两个素不相识的人因为一次偶然的相遇而命运交织。温柔细腻的画风搭配感人至深的剧情，讲述了一段跨越阶级的真挚爱情故事。女主角是一位普通的花店店员，男主角则是大型企业的继承人，两人在星光下许下了永恒的约定。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20webtoon%20cover%20two%20people%20under%20starry%20night%20sky%20soft%20warm%20pastel%20colors%20clean%20illustration%20style%20simple%20background&width=600&height=800&seq=cover-01&orientation=portrait',
    rating: 9.5, views: 2850000, status: '连载中', updatedAt: '2026-08-04',
    isHot: true, isNew: false, tags: ['热门', '推荐', '高分'],
    chapters: [
      { id: 'c1-1', number: 1, title: chTitles[0], updatedAt: ch(1, 5) },
      { id: 'c1-2', number: 2, title: chTitles[1], updatedAt: ch(1, 12) },
      { id: 'c1-3', number: 3, title: chTitles[2], updatedAt: ch(1, 19) },
      { id: 'c1-4', number: 4, title: chTitles[3], updatedAt: ch(1, 26) },
      { id: 'c1-5', number: 5, title: chTitles[4], updatedAt: ch(2, 2) },
      { id: 'c1-6', number: 6, title: chTitles[5], updatedAt: ch(2, 9) },
      { id: 'c1-7', number: 7, title: chTitles[6], updatedAt: ch(2, 16) },
      { id: 'c1-8', number: 8, title: chTitles[7], updatedAt: ch(2, 23) },
      { id: 'c1-9', number: 9, title: chTitles[8], updatedAt: ch(3, 1) },
      { id: 'c1-10', number: 10, title: chTitles[9], updatedAt: ch(3, 8) },
      { id: 'c1-11', number: 11, title: chTitles[10], updatedAt: ch(3, 15) },
      { id: 'c1-12', number: 12, title: chTitles[11], updatedAt: ch(3, 22) },
    ],
  },
  {
    id: '2', slug: 'magic-academy', title: '魔法学院的秘密', author: '朴成浩',
    category: '奇幻', categorySlug: 'fantasy',
    description: '平凡的高中生李恩宇意外收到了魔法学院的入学通知书。在这所神秘的学院里，他发现了隐藏在魔法世界背后的惊天秘密。华丽的魔法特效搭配紧张的剧情节奏，带你进入一个充满想象力的奇幻世界。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20webtoon%20cover%20magic%20academy%20young%20male%20character%20with%20magical%20powers%20mystical%20atmosphere%20vibrant%20colors%20clean%20illustration%20simple%20background&width=600&height=800&seq=cover-02&orientation=portrait',
    rating: 9.3, views: 2100000, status: '连载中', updatedAt: '2026-08-03',
    isHot: true, isNew: false, tags: ['热门', '独家', '高分'],
    chapters: [
      { id: 'c2-1', number: 1, title: chTitles[0], updatedAt: ch(2, 3) },
      { id: 'c2-2', number: 2, title: chTitles[1], updatedAt: ch(2, 10) },
      { id: 'c2-3', number: 3, title: chTitles[2], updatedAt: ch(2, 17) },
      { id: 'c2-4', number: 4, title: chTitles[3], updatedAt: ch(2, 24) },
      { id: 'c2-5', number: 5, title: chTitles[4], updatedAt: ch(3, 3) },
      { id: 'c2-6', number: 6, title: chTitles[5], updatedAt: ch(3, 10) },
      { id: 'c2-7', number: 7, title: chTitles[6], updatedAt: ch(3, 17) },
      { id: 'c2-8', number: 8, title: chTitles[7], updatedAt: ch(3, 24) },
      { id: 'c2-9', number: 9, title: chTitles[8], updatedAt: ch(4, 1) },
      { id: 'c2-10', number: 10, title: chTitles[9], updatedAt: ch(4, 8) },
    ],
  },
  {
    id: '3', slug: 'shadow-hunter', title: '暗影猎人', author: '崔敏俊',
    category: '动作', categorySlug: 'action',
    description: '在黑暗的地下世界中，一群拥有特殊能力的猎人以猎杀怪物为生。主角姜浩宇是其中最出色的暗影猎人，但他身上隐藏着一个足以毁灭世界的秘密。快节奏的战斗场面和精美的动作分镜，让你体会肾上腺素飙升的快感。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20webtoon%20cover%20dark%20hunter%20character%20with%20weapon%20dynamic%20pose%20dramatic%20lighting%20intense%20atmosphere%20clean%20illustration%20simple%20dark%20background&width=600&height=800&seq=cover-03&orientation=portrait',
    rating: 9.1, views: 1950000, status: '连载中', updatedAt: '2026-08-02',
    isHot: true, isNew: false, tags: ['热门', '推荐'],
    chapters: [
      { id: 'c3-1', number: 1, title: chTitles[0], updatedAt: ch(2, 5) },
      { id: 'c3-2', number: 2, title: chTitles[1], updatedAt: ch(2, 12) },
      { id: 'c3-3', number: 3, title: chTitles[2], updatedAt: ch(2, 19) },
      { id: 'c3-4', number: 4, title: chTitles[3], updatedAt: ch(2, 26) },
      { id: 'c3-5', number: 5, title: chTitles[4], updatedAt: ch(3, 5) },
      { id: 'c3-6', number: 6, title: chTitles[5], updatedAt: ch(3, 12) },
      { id: 'c3-7', number: 7, title: chTitles[6], updatedAt: ch(3, 19) },
      { id: 'c3-8', number: 8, title: chTitles[7], updatedAt: ch(3, 26) },
      { id: 'c3-9', number: 9, title: chTitles[8], updatedAt: ch(4, 3) },
      { id: 'c3-10', number: 10, title: chTitles[9], updatedAt: ch(4, 10) },
    ],
  },
  {
    id: '4', slug: 'city-of-lies', title: '谎言都市', author: '尹瑞妍',
    category: '悬疑', categorySlug: 'thriller',
    description: '首尔市中心连续发生离奇失踪案件，刑警韩瑞珍在调查过程中逐渐发现，所有线索都指向一个名为"谎言都市"的地下组织。每当你以为接近真相时，剧情就会来一个180度大反转。烧脑程度满分！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20webtoon%20cover%20dark%20city%20alley%20female%20detective%20character%20mysterious%20atmosphere%20noir%20lighting%20clean%20illustration%20simple%20dark%20background&width=600&height=800&seq=cover-04&orientation=portrait',
    rating: 9.4, views: 1760000, status: '连载中', updatedAt: '2026-08-04',
    isHot: false, isNew: false, tags: ['推荐', '高分'],
    chapters: [
      { id: 'c4-1', number: 1, title: chTitles[0], updatedAt: ch(3, 2) },
      { id: 'c4-2', number: 2, title: chTitles[1], updatedAt: ch(3, 9) },
      { id: 'c4-3', number: 3, title: chTitles[2], updatedAt: ch(3, 16) },
      { id: 'c4-4', number: 4, title: chTitles[3], updatedAt: ch(3, 23) },
      { id: 'c4-5', number: 5, title: chTitles[4], updatedAt: ch(4, 1) },
      { id: 'c4-6', number: 6, title: chTitles[5], updatedAt: ch(4, 8) },
      { id: 'c4-7', number: 7, title: chTitles[6], updatedAt: ch(4, 15) },
      { id: 'c4-8', number: 8, title: chTitles[7], updatedAt: ch(4, 22) },
    ],
  },
  {
    id: '5', slug: 'daily-laugh', title: '隔壁的搞笑日常', author: '韩志浩',
    category: '喜剧', categorySlug: 'comedy',
    description: '四个性格迥异的邻居住在同一栋公寓里，每天上演着让人捧腹大笑的日常故事。从外卖点错到电梯故障，每一件小事都能引发一场喜剧大戏。轻松愉快的阅读体验，是缓解压力的最佳选择。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20webtoon%20cover%20four%20funny%20characters%20in%20apartment%20bright%20colorful%20style%20cheerful%20atmosphere%20clean%20illustration%20simple%20background&width=600&height=800&seq=cover-05&orientation=portrait',
    rating: 8.9, views: 1620000, status: '已完结', updatedAt: '2026-07-20',
    isHot: false, isNew: false, tags: ['完结', '免费'],
    chapters: [
      { id: 'c5-1', number: 1, title: chTitles[0], updatedAt: ch(1, 8) },
      { id: 'c5-2', number: 2, title: chTitles[1], updatedAt: ch(1, 15) },
      { id: 'c5-3', number: 3, title: chTitles[2], updatedAt: ch(1, 22) },
      { id: 'c5-4', number: 4, title: chTitles[3], updatedAt: ch(2, 1) },
      { id: 'c5-5', number: 5, title: chTitles[4], updatedAt: ch(2, 8) },
      { id: 'c5-6', number: 6, title: chTitles[5], updatedAt: ch(2, 15) },
      { id: 'c5-7', number: 7, title: chTitles[6], updatedAt: ch(2, 22) },
      { id: 'c5-8', number: 8, title: chTitles[7], updatedAt: ch(3, 1) },
      { id: 'c5-9', number: 9, title: chTitles[8], updatedAt: ch(3, 8) },
      { id: 'c5-10', number: 10, title: chTitles[9], updatedAt: ch(3, 15) },
    ],
  },
  {
    id: '6', slug: 'tears-of-autumn', title: '秋天的眼泪', author: '李秀雅',
    category: '剧情', categorySlug: 'drama',
    description: '这是一个关于失去与重生的故事。女主角在失去至亲后，独自来到济州岛开始新的生活。在那里，她遇到了同样背负着过去的男主角。细腻的情感描写和优美的海岛风景，构成了这部感人至深的剧情漫画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20webtoon%20cover%20woman%20on%20Jeju%20island%20autumn%20atmosphere%20emotional%20warm%20but%20melancholic%20colors%20clean%20illustration%20simple%20background&width=600&height=800&seq=cover-06&orientation=portrait',
    rating: 9.6, views: 2300000, status: '已完结', updatedAt: '2026-06-15',
    isHot: true, isNew: false, tags: ['完结', '推荐', '高分'],
    chapters: [
      { id: 'c6-1', number: 1, title: chTitles[0], updatedAt: ch(1, 3) },
      { id: 'c6-2', number: 2, title: chTitles[1], updatedAt: ch(1, 10) },
      { id: 'c6-3', number: 3, title: chTitles[2], updatedAt: ch(1, 17) },
      { id: 'c6-4', number: 4, title: chTitles[3], updatedAt: ch(1, 24) },
      { id: 'c6-5', number: 5, title: chTitles[4], updatedAt: ch(2, 1) },
      { id: 'c6-6', number: 6, title: chTitles[5], updatedAt: ch(2, 8) },
      { id: 'c6-7', number: 7, title: chTitles[6], updatedAt: ch(2, 15) },
      { id: 'c6-8', number: 8, title: chTitles[7], updatedAt: ch(2, 22) },
      { id: 'c6-9', number: 9, title: chTitles[8], updatedAt: ch(3, 1) },
      { id: 'c6-10', number: 10, title: chTitles[9], updatedAt: ch(3, 8) },
      { id: 'c6-11', number: 11, title: chTitles[10], updatedAt: ch(3, 15) },
      { id: 'c6-12', number: 12, title: chTitles[11], updatedAt: ch(3, 22) },
    ],
  },
  {
    id: '7', slug: 'campus-love-story', title: '校园恋爱手册', author: '郑恩彩',
    category: '恋爱', categorySlug: 'romance',
    description: '大学校园里，学霸女主角和校草男主角因为一次小组作业而相遇。从一开始的互相看不顺眼到慢慢发现对方的优点，一场甜蜜的校园恋爱就此展开。清新的画风配上青春洋溢的剧情，让你重回那段美好的校园时光。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20webtoon%20cover%20university%20campus%20couple%20youthful%20fresh%20style%20spring%20cherry%20blossoms%20clean%20illustration%20simple%20background&width=600&height=800&seq=cover-07&orientation=portrait',
    rating: 9.0, views: 1450000, status: '连载中', updatedAt: '2026-08-01',
    isHot: false, isNew: true, tags: ['新作', '推荐'],
    chapters: [
      { id: 'c7-1', number: 1, title: chTitles[0], updatedAt: ch(4, 5) },
      { id: 'c7-2', number: 2, title: chTitles[1], updatedAt: ch(4, 12) },
      { id: 'c7-3', number: 3, title: chTitles[2], updatedAt: ch(4, 19) },
      { id: 'c7-4', number: 4, title: chTitles[3], updatedAt: ch(4, 26) },
      { id: 'c7-5', number: 5, title: chTitles[4], updatedAt: ch(5, 3) },
      { id: 'c7-6', number: 6, title: chTitles[5], updatedAt: ch(5, 10) },
      { id: 'c7-7', number: 7, title: chTitles[6], updatedAt: ch(5, 17) },
      { id: 'c7-8', number: 8, title: chTitles[7], updatedAt: ch(5, 24) },
    ],
  },
  {
    id: '8', slug: 'dragon-king-reborn', title: '龙王重生记', author: '姜泰元',
    category: '奇幻', categorySlug: 'fantasy',
    description: '曾经统治龙族的最强龙王在一场背叛中被杀害，却意外重生为一千年后的人类少年。带着前世的记忆和力量，他开始了寻找真相和复仇的旅程。宏大的世界观设定和精美的战斗场景，这部作品不容错过。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20webtoon%20cover%20dragon%20theme%20reborn%20warrior%20character%20epic%20fantasy%20style%20dramatic%20lighting%20clean%20illustration%20simple%20background&width=600&height=800&seq=cover-08&orientation=portrait',
    rating: 9.2, views: 1980000, status: '连载中', updatedAt: '2026-08-03',
    isHot: true, isNew: false, tags: ['热门', '独家'],
    chapters: [
      { id: 'c8-1', number: 1, title: chTitles[0], updatedAt: ch(2, 6) },
      { id: 'c8-2', number: 2, title: chTitles[1], updatedAt: ch(2, 13) },
      { id: 'c8-3', number: 3, title: chTitles[2], updatedAt: ch(2, 20) },
      { id: 'c8-4', number: 4, title: chTitles[3], updatedAt: ch(2, 27) },
      { id: 'c8-5', number: 5, title: chTitles[4], updatedAt: ch(3, 6) },
      { id: 'c8-6', number: 6, title: chTitles[5], updatedAt: ch(3, 13) },
      { id: 'c8-7', number: 7, title: chTitles[6], updatedAt: ch(3, 20) },
      { id: 'c8-8', number: 8, title: chTitles[7], updatedAt: ch(3, 27) },
      { id: 'c8-9', number: 9, title: chTitles[8], updatedAt: ch(4, 4) },
      { id: 'c8-10', number: 10, title: chTitles[9], updatedAt: ch(4, 11) },
    ],
  },
  {
    id: '9', slug: 'night-detective', title: '深夜侦探事务所', author: '安在赫',
    category: '悬疑', categorySlug: 'thriller',
    description: '只在深夜营业的神秘侦探事务所，接受各种匪夷所思的委托。从寻找失踪的宠物到调查超自然现象，每一个案件背后都隐藏着不为人知的黑暗真相。独特的叙事风格和出人意料的结局，让你欲罢不能。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20webtoon%20cover%20detective%20office%20at%20night%20mysterious%20atmosphere%20noir%20style%20dramatic%20shadows%20clean%20illustration%20simple%20dark%20background&width=600&height=800&seq=cover-09&orientation=portrait',
    rating: 8.8, views: 1350000, status: '连载中', updatedAt: '2026-08-04',
    isHot: false, isNew: true, tags: ['新作'],
    chapters: [
      { id: 'c9-1', number: 1, title: chTitles[0], updatedAt: ch(5, 1) },
      { id: 'c9-2', number: 2, title: chTitles[1], updatedAt: ch(5, 8) },
      { id: 'c9-3', number: 3, title: chTitles[2], updatedAt: ch(5, 15) },
      { id: 'c9-4', number: 4, title: chTitles[3], updatedAt: ch(5, 22) },
      { id: 'c9-5', number: 5, title: chTitles[4], updatedAt: ch(6, 1) },
      { id: 'c9-6', number: 6, title: chTitles[5], updatedAt: ch(6, 8) },
    ],
  },
  {
    id: '10', slug: 'fighting-spirit', title: '格斗之王', author: '权赫秀',
    category: '动作', categorySlug: 'action',
    description: '出身平凡的少年崔东旭拥有惊人的格斗天赋，在地下格斗场一步步成长为无人能敌的格斗之王。每一场战斗都刻画得淋漓尽致，拳拳到肉的打击感让人热血沸腾。这是近年来最出色的动作漫画之一。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20webtoon%20cover%20fighter%20in%20dynamic%20pose%20martial%20arts%20theme%20intense%20style%20dramatic%20lighting%20clean%20illustration%20simple%20background&width=600&height=800&seq=cover-10&orientation=portrait',
    rating: 9.0, views: 1580000, status: '连载中', updatedAt: '2026-08-02',
    isHot: false, isNew: false, tags: ['推荐'],
    chapters: [
      { id: 'c10-1', number: 1, title: chTitles[0], updatedAt: ch(3, 4) },
      { id: 'c10-2', number: 2, title: chTitles[1], updatedAt: ch(3, 11) },
      { id: 'c10-3', number: 3, title: chTitles[2], updatedAt: ch(3, 18) },
      { id: 'c10-4', number: 4, title: chTitles[3], updatedAt: ch(3, 25) },
      { id: 'c10-5', number: 5, title: chTitles[4], updatedAt: ch(4, 2) },
      { id: 'c10-6', number: 6, title: chTitles[5], updatedAt: ch(4, 9) },
      { id: 'c10-7', number: 7, title: chTitles[6], updatedAt: ch(4, 16) },
      { id: 'c10-8', number: 8, title: chTitles[7], updatedAt: ch(4, 23) },
    ],
  },
  {
    id: '11', slug: 'office-romance', title: '办公室罗曼史', author: '朴美英',
    category: '恋爱', categorySlug: 'romance',
    description: '广告公司里，王牌策划师和新人设计师之间的办公室恋情。专业能力的碰撞与职场生活的真实写照，夹杂着甜蜜的暧昧与心动的瞬间。成熟的爱情观和职场描绘让这部作品在职场人群中广受欢迎。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20webtoon%20cover%20office%20couple%20theme%20professional%20elegant%20style%20warm%20lighting%20clean%20illustration%20simple%20background&width=600&height=800&seq=cover-11&orientation=portrait',
    rating: 8.7, views: 1280000, status: '已完结', updatedAt: '2026-05-30',
    isHot: false, isNew: false, tags: ['完结', '免费'],
    chapters: [
      { id: 'c11-1', number: 1, title: chTitles[0], updatedAt: ch(1, 7) },
      { id: 'c11-2', number: 2, title: chTitles[1], updatedAt: ch(1, 14) },
      { id: 'c11-3', number: 3, title: chTitles[2], updatedAt: ch(1, 21) },
      { id: 'c11-4', number: 4, title: chTitles[3], updatedAt: ch(1, 28) },
      { id: 'c11-5', number: 5, title: chTitles[4], updatedAt: ch(2, 5) },
      { id: 'c11-6', number: 6, title: chTitles[5], updatedAt: ch(2, 12) },
      { id: 'c11-7', number: 7, title: chTitles[6], updatedAt: ch(2, 19) },
      { id: 'c11-8', number: 8, title: chTitles[7], updatedAt: ch(2, 26) },
      { id: 'c11-9', number: 9, title: chTitles[8], updatedAt: ch(3, 5) },
      { id: 'c11-10', number: 10, title: chTitles[9], updatedAt: ch(3, 12) },
    ],
  },
  {
    id: '12', slug: 'food-truck-diary', title: '餐车日记', author: '宋智恩',
    category: '喜剧', categorySlug: 'comedy',
    description: '被大公司裁员后，男主角开着一辆旧餐车开始了全国旅行。一路上遇到了形形色色的客人和有趣的挑战，用美食治愈自己也温暖他人。温馨搞笑又充满人情味，每一话都会介绍一道美食的做法。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20webtoon%20cover%20food%20truck%20theme%20warm%20cheerful%20style%20bright%20colors%20clean%20illustration%20simple%20background&width=600&height=800&seq=cover-12&orientation=portrait',
    rating: 8.6, views: 1100000, status: '连载中', updatedAt: '2026-08-01',
    isHot: false, isNew: true, tags: ['新作', '免费'],
    chapters: [
      { id: 'c12-1', number: 1, title: chTitles[0], updatedAt: ch(5, 3) },
      { id: 'c12-2', number: 2, title: chTitles[1], updatedAt: ch(5, 10) },
      { id: 'c12-3', number: 3, title: chTitles[2], updatedAt: ch(5, 17) },
      { id: 'c12-4', number: 4, title: chTitles[3], updatedAt: ch(5, 24) },
      { id: 'c12-5', number: 5, title: chTitles[4], updatedAt: ch(6, 3) },
      { id: 'c12-6', number: 6, title: chTitles[5], updatedAt: ch(6, 10) },
    ],
  },
];

export const homeSections = {
  heroComics: comics.filter(c => c.isHot).slice(0, 5),
  hotComics: comics.filter(c => c.isHot),
  newComics: comics.filter(c => c.isNew),
  completedComics: comics.filter(c => c.status === '已完结'),
  topRated: [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10),
  latestUpdates: [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8),
};

export const categoryData: Record<string, Comic[]> = {};
categories.forEach(cat => {
  categoryData[cat.slug] = comics.filter(c => c.categorySlug === cat.slug);
});